import { usage as usageApi } from '@afosto/iam/api/Usage';

export default async ({ unit, code, startAt, endAt, interval, as, filter, keys }) => {
  try {
    const response = await usageApi.queryUsage({
      interval,
      code,
      unit,
      as,
      filter,
      keys,
      start_at: startAt,
      end_at: endAt,
    });
    const { data } = response;
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};
